export default __webpack_public_path__ + "static/media/schoology.4644158f.png";